module.exports = ".alert-form {\n  position: fixed;\n  top: 30px;\n  left: 0;\n  right: 0;\n  z-index: 996;\n  margin: 0 60px;\n  text-align: center; }\n"